import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['scope']

  selectAll(event) {
    if (event) event.preventDefault()

    const root = this.hasScopeTarget ? this.scopeTarget : this.element
    root.querySelectorAll('input[type="checkbox"]:not(:disabled)').forEach((checkbox) => {
      checkbox.checked = true
      checkbox.dispatchEvent(new Event('checkbox:checked', { bubbles: true }))
    })
  }

  deselectAll(event) {
    if (event) event.preventDefault()

    const root = this.hasScopeTarget ? this.scopeTarget : this.element
    root.querySelectorAll('input[type="checkbox"]:not(:disabled)').forEach((checkbox) => {
      checkbox.checked = false
      checkbox.dispatchEvent(new Event('checkbox:unchecked', { bubbles: true }))
    })
  }

  toggleAll(event) {
    if (event) event.preventDefault()

    const root = this.hasScopeTarget ? this.scopeTarget : this.element
    root.querySelectorAll('input[type="checkbox"]:not(:disabled)').forEach((checkbox) => {
      checkbox.checked = !checkbox.checked
      checkbox.dispatchEvent(new Event('checkbox:toggled', { bubbles: true }))
    })
  }
}
